
export default {
  name: 'HomeSkeletonBuyAsSet',
  data: () => ({
  }),
};
